module.exports = __webpack_public_path__ + "static/media/main-bg2.fefe3c45.jpg";